import { createClass as _createClass, classCallCheck as _classCallCheck } from './_virtual/_rollupPluginBabelHelpers.js';
import Env from './env.js';
import { firstToUpper } from './format.js';

var Enum = /*#__PURE__*/function () {
  function Enum(slug) {
    _classCallCheck(this, Enum);

    this.slug = slug;
  }

  _createClass(Enum, [{
    key: "label",
    value: function label(value) {
      var label = this.raw[value];

      if (typeof label === 'string') {
        label = firstToUpper(label);
      }

      return label;
    }
  }, {
    key: "raw",
    get: function get() {
      return Env.get('enums.' + this.slug, {});
    }
  }, {
    key: "options",
    get: function get() {
      var options = this.raw;
      return Object.keys(options).map(function (option) {
        return {
          label: firstToUpper(options[option]),
          value: option
        };
      });
    }
  }], [{
    key: "labelFromSlug",
    value: function labelFromSlug(slug, value) {
      return new Enum(slug).label(value);
    }
  }]);

  return Enum;
}();

export default Enum;
//# sourceMappingURL=Enum.js.map
